import { fermerSession, useGetQuery } from '../../Utils/api';
import React, { ReactElement, useState } from 'react';
import { Button, ButtonGroup, Col, Container, Dropdown, DropdownButton, Nav, Navbar, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useRecoilState } from 'recoil';
import { currentModalPageState, etatUtilisateurConnecte } from '../../State';
import '../../Styles/Navbar.scss';
import { useLocation, useNavigate } from 'react-router';
import { usePreserveQuery } from '../../Utils/usePreserveQuery';
import { ActiviteVitrine } from '../../../../common/src/entities';
import BarreRechercheVitrine from './BarreRechercheVitrine/BarreRechercheVitrine';
import LanguageSwitcher from '../Common/LanguageSwitcher';
import { PAGES_FULLY_TRANSLATED } from '../Common/LanguageSwitcher';
import ToggleSwitch from '../Common/ToggleSwitchComponent';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { BsQuestion } from 'react-icons/bs';
import './DropdownMenu.scss';
import StepperModal from '../Common/StepperModal';
import ForfaitAlaCarte from '../Common/Politiques/ForfaitALaCarte';
import ForfaitAbonnement from '../Common/Politiques/ForfaitAbonnement';
import InfoCard from '../InfoCard';
import '../../Styles/Vitrine/Video.scss';

import { FaChevronDown } from 'react-icons/fa';
import Banner from '../Common/Banniere';

export interface PropsMyNavbar {
    affichageActivitePublic: boolean;
    setAffichageActivitePublic: React.Dispatch<React.SetStateAction<boolean>>;
    onOpenPolitique: () => void;
    onGoToFaq: () => void;
}

export default function MyNavbar(props: PropsMyNavbar): ReactElement {
    const goToAbonnement = () => {
        setShowOffreDeServervie(false);
        navigate('/CreerCompte');
    };
    const APropos = [
        <img src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/raisons_de_travailler_avec_SA.png"></img>,
    ];
    const OffreDeService = [
        <div>
            {' '}
            <br></br>
            <h1 style={{ textAlign: 'center', fontFamily: 'sans-serif' }}>Deux manières d'utiliser nos services</h1>
            <br></br>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'space-evenly' }}>
                <ForfaitAlaCarte
                    boutonOnclick={() => {
                        setCurrentModalPage(2);
                    }}
                ></ForfaitAlaCarte>
                <ForfaitAbonnement buttonfunction={goToAbonnement}></ForfaitAbonnement>
            </div>
        </div>,
    ];
    const CommentUtiliserLeSite = [
        <div>
            <video
                width="100%"
                height="auto"
                controls
                poster="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/SA_horizontal_couleur_HR_play_button.png"
                className="hide-play-button"
            >
                <source src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Videos/tutosa1080p.mp4" />
            </video>
            <div>
                <InfoCard></InfoCard>
            </div>
        </div>,
    ];
    const EtapeDeReservation = [
        <img src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/Les_etapes_dune_reservation_modif.png"></img>,
    ];

    const navigate = useNavigate();
    const location = useLocation();
    const [showApropos, setShowApropos] = useState(false);
    const [showOffreDeServervie, setShowOffreDeServervie] = useState(false);
    const [showCommentUtiliserLeSite, setShowCommentUtiliserLeSite] = useState(false);
    const [showEtapeDeReservation, setShowEtapeDeReservation] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const { data: countPublic } = useGetQuery<number>(['activites', 'countPublic']);

    const [currentModalPage, setCurrentModalPage] = useRecoilState(currentModalPageState);

    const { data: activitesVisibles }: { data: ActiviteVitrine[] | undefined } = useGetQuery<ActiviteVitrine[]>([
        'activites',
        'vitrine',
    ]);
    const { data: nbTotalActivites } = useGetQuery<number>(['activites', 'count']);

    const handleFaqClickButton = () => {
        props.onGoToFaq();
    };
    const handlePolitiqueClickButton = () => {
        props.onOpenPolitique();
    };
    const preserveQuery = usePreserveQuery();

    const [utilisateurConnecte, setEtatUtilisateurConnecte] = useRecoilState(etatUtilisateurConnecte);

    const fixFlexIE: React.CSSProperties = { flexBasis: 'auto', width: 'auto' };

    const nbActivites = nbTotalActivites
        ? `${
              utilisateurConnecte.connecte && !props.affichageActivitePublic ? nbTotalActivites : countPublic
          } sur ${nbTotalActivites}`
        : '...';

    const scrollToSection = (id: string, offset: number) => {
        const section = document.getElementById(id);
        if (section) {
            const yOffset = -offset;
            const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    const handleScrollOrNavigate = (sectionId: string) => {
        if (location.pathname === '/') {
            scrollToSection(sectionId, 50);
        } else {
            navigate(`/?id=${sectionId}`);
            setTimeout(() => {
                scrollToSection(sectionId, 50);
            }, 500); // Attendez 1 seconde avant de défiler et de jouer la vidéo
        }
    };

    return (
        <Navbar
            bg="light"
            expand="lg"
            fixed="top"
            className="navbar-vitrine flex-column pb-0 position-static position-sticky"
        >
            <Container fluid className="container-vitrine">
                <Row className="align-items-center flex-grow-1">
                    <Col className="flex-grow-1 flex-lg-grow-0 py-2 py-lg-0" style={fixFlexIE}>
                        <LinkContainer to="/">
                            <Navbar.Brand>
                                <img
                                    style={{ mixBlendMode: 'multiply' }}
                                    alt="solution-animation"
                                    src="https://images-jp-prod.nyc3.cdn.digitaloceanspaces.com/Images/Misc/logo_solanim.jpg"
                                    height={40}
                                />
                            </Navbar.Brand>
                        </LinkContainer>
                    </Col>
                    <Col className="d-lg-none flex-grow-0" style={fixFlexIE}>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    </Col>
                    <Col xs={12} lg className="py-2 py-lg-0">
                        <BarreRechercheVitrine toggleEstPublic={props.affichageActivitePublic} />
                    </Col>

                    <Dropdown>
                        <Dropdown.Toggle
                            id="dropdown-basic"
                            style={{
                                height: '2.375rem',
                                display: 'flex',
                                alignItems: 'center',
                                backgroundColor: 'transparent',
                                border: 'none',
                            }}
                        >
                            <BsQuestion
                                className="dropdown-icon"
                                style={{ fontSize: '2rem' }}
                                aria-label="Information"
                            ></BsQuestion>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {' '}
                            <Dropdown.Item
                                onClick={() => {
                                    setShowApropos(true);
                                }}
                            >
                                À propos
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    setShowOffreDeServervie(true);
                                }}
                            >
                                Offre de service
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    setShowCommentUtiliserLeSite(true);
                                }}
                            >
                                Comment utiliser le site?
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    setShowEtapeDeReservation(true);
                                }}
                            >
                                Étapes de reservation
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    handleFaqClickButton();
                                }}
                            >
                                FAQ
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => {
                                    handlePolitiqueClickButton();
                                }}
                            >
                                Politique d'utilisation
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Col className="flex-lg-grow-0 pt-2 pt-lg-0" style={fixFlexIE}>
                        <Navbar.Collapse id="basic-navbar-nav">
                            {utilisateurConnecte.connecte ? (
                                <>
                                    <DropdownButton
                                        id="dropdown-basic-button"
                                        variant="outline-secondary"
                                        title={
                                            utilisateurConnecte.prenom
                                                ? utilisateurConnecte.prenom + ' ' + utilisateurConnecte.nom
                                                : utilisateurConnecte.nom
                                        }
                                    >
                                        <Dropdown.Item
                                            onClick={() => {
                                                navigate('/profile', { replace: true });
                                            }}
                                        >
                                            Profil
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() => {
                                                fermerSession();
                                                navigate('/', { replace: true });
                                                setEtatUtilisateurConnecte({
                                                    id: 0,
                                                    connecte: false,
                                                    admin: false,
                                                    nom: '',
                                                    prenom: '',
                                                    mettreAJourMotDePasse: false,
                                                });
                                            }}
                                        >
                                            Se&nbsp;déconnecter
                                        </Dropdown.Item>
                                    </DropdownButton>
                                </>
                            ) : (
                                <LinkContainer to="/login">
                                    <Nav.Link as={Button} variant="outline-primary" size="sm" className="w-100">
                                        Se&nbsp;connecter
                                    </Nav.Link>
                                </LinkContainer>
                            )}
                        </Navbar.Collapse>
                    </Col>
                    <ToggleSwitch
                        leftText={'Abonné'}
                        rightText={'Public'}
                        leftIcon={<FiEye></FiEye>}
                        rightIcon={<FiEyeOff></FiEyeOff>}
                        estActif={!props.affichageActivitePublic}
                        setEstActif={props.setAffichageActivitePublic}
                    ></ToggleSwitch>
                    {PAGES_FULLY_TRANSLATED.includes(location.pathname) ? (
                        <Col className="flex-lg-grow-0 pt-2 pt-lg-0" style={fixFlexIE}>
                            <LanguageSwitcher />
                        </Col>
                    ) : undefined}
                </Row>
            </Container>
            <div className="bg-light w-100 ">
                <Container fluid className="container-vitrine">
                    <Row className="align-items-center flex-grow-1">
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="flex-grow-1 justify-content-center">
                                <Col xs="auto">
                                    <ButtonGroup>
                                        <LinkContainer to="/">
                                            <Nav.Link>Accueil</Nav.Link>
                                        </LinkContainer>
                                        <Dropdown as={ButtonGroup}>
                                            <Dropdown.Toggle
                                                split
                                                variant="link"
                                                id="dropdown-split-basic"
                                                style={{ color: '#6c757d' }}
                                            >
                                                <FaChevronDown />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    as="button"
                                                    onClick={() => handleScrollOrNavigate('section-pedagogique')}
                                                >
                                                    Pédagogique
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    as="button"
                                                    onClick={() => handleScrollOrNavigate('section-parascolaire')}
                                                >
                                                    Parascolaire
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    as="button"
                                                    onClick={() => handleScrollOrNavigate('section-fournisseur')}
                                                >
                                                    Fournisseur
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </ButtonGroup>
                                </Col>
                                <Col xs="auto">
                                    <LinkContainer to={preserveQuery('activites')}>
                                        <Nav.Link>Liste des activités ({nbActivites})</Nav.Link>
                                    </LinkContainer>
                                </Col>
                                <Col xs="auto">
                                    <LinkContainer to="transport">
                                        <Nav.Link>Transport</Nav.Link>
                                    </LinkContainer>
                                </Col>
                                <Col xs="auto">
                                    <LinkContainer to="reservation">
                                        <Nav.Link>Demande de réservation</Nav.Link>
                                    </LinkContainer>
                                </Col>
                                {utilisateurConnecte.connecte && utilisateurConnecte.admin ? (
                                    <>
                                        <Col xs="auto">
                                            <LinkContainer to="dashboard">
                                                <Nav.Link>Dashboard</Nav.Link>
                                            </LinkContainer>
                                        </Col>
                                    </>
                                ) : null}
                                <Col xs="auto">
                                    <LinkContainer to="nousjoindre">
                                        <Nav.Link>Nous joindre</Nav.Link>
                                    </LinkContainer>
                                </Col>
                            </Nav>
                        </Navbar.Collapse>
                    </Row>
                </Container>
                <Banner></Banner>
            </div>
            <StepperModal
                modals={APropos}
                finishText="Fermer"
                show={showApropos}
                finishButtonVariant="primary"
                finishButtonOnClick={() => {
                    setShowApropos(false);
                }}
                onHide={handleClose}
            ></StepperModal>
            <StepperModal
                modals={OffreDeService}
                finishText="Fermer"
                show={showOffreDeServervie}
                finishButtonVariant="primary"
                finishButtonOnClick={() => {
                    setShowOffreDeServervie(false);
                }}
                onHide={handleClose}
            ></StepperModal>
            <StepperModal
                modals={CommentUtiliserLeSite}
                finishText="Fermer"
                show={showCommentUtiliserLeSite}
                finishButtonVariant="primary"
                finishButtonOnClick={() => {
                    setShowCommentUtiliserLeSite(false);
                }}
                onHide={handleClose}
            ></StepperModal>
            <StepperModal
                modals={EtapeDeReservation}
                finishText="Fermer"
                show={showEtapeDeReservation}
                finishButtonVariant="primary"
                finishButtonOnClick={() => {
                    setShowEtapeDeReservation(false);
                }}
                onHide={handleClose}
            ></StepperModal>
        </Navbar>
    );
}
